import './gutters.module-c9c70930.js';
import 'classnames';
import 'react';
import './utils/index.js';
import { Row } from './row/Component.js';
import { Col } from './col/Component.js';

var Grid = {
    Row: Row,
    Col: Col,
};

export { Grid };
